<template>
  <div>
    <!-- <v-btn class="setting-fab"
           color="primary"
           @click="openThemeSettings"
           small
           fab
           dark
           fixed>
      <v-icon>palette</v-icon>
    </v-btn> -->
    <v-navigation-drawer
      class="appDrawer"
      v-model="rightDrawer"
      hide-overlay
      clipped
      temporary
      right
      fixed
      app
    >
      <v-toolbar color="primary" flat dark>
        <v-toolbar-title class="subheading">
          Pengaturan Tema Dalam
        </v-toolbar-title>
      </v-toolbar>
      <vue-perfect-scrollbar
        class="drawer-menu--scroll"
        :settings="scrollSettings"
      >
        <v-container class="py-4">
          <v-layout>
            <v-flex>
              <v-radio-group
                v-model="lightOption"
                class="ma-0 pa-0"
                hide-details
                label="Mode Pencahayaan"
                mandatory
              >
                <v-radio value="dark" label="GELAP"></v-radio>
                <v-radio value="light" label="TERANG"></v-radio>
              </v-radio-group>

              <v-subheader class="px-1"> Pilihan Warna </v-subheader>
              <div class="color-option">
                <v-layout wrap>
                  <label
                    class="color-option--label flex xs6 pa-1"
                    v-for="option in themeColorOptions"
                    :key="`color-options-${option.key}`"
                  >
                    <input
                      type="radio"
                      name="color"
                      :value="option.key"
                      v-model="themeColor"
                    />
                    <span class="color-option--item bg">
                      <span class="overlay">
                        <span class="material-icons">check</span>
                      </span>
                      <span
                        class="color-option--item--header sideNav"
                        :class="option.value.sideNav"
                      ></span>
                      <span
                        class="color-option--item--header mainNav"
                        :class="option.value.mainNav"
                      ></span>
                      <span
                        class="sideMenu"
                        :class="option.value.sideManu"
                      ></span>
                    </span>
                  </label>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </vue-perfect-scrollbar>
    </v-navigation-drawer>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import colors from "vuetify/es5/util/colors";
import Themes from "@/constants/themes";
import { mapState } from "vuex";

export default {
  name: "app-theme-settings",
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      colors: colors,
      themeColorOptions: Themes,
      scrollSettings: {
        maxScrollbarLength: 200,
        wheelSpeed: 0.1
      }
    };
  },
  computed: {
    ...mapState(["ui"]),
    rightDrawer: {
      get() {
        return this.ui.rightSidebar;
      },
      set(value) {
        this.$store.commit("SET_RIGHT_SIDEBAR", value);
      }
    },
    themeColor: {
      get() {
        return this.ui.themeColor;
      },
      set(val) {
        this.$vuetify.theme.primary = this.colors[val].base;
        this.$vuetify.theme.secondary = this.colors[val].lighten2;
        this.$store.dispatch("SET_THEME_COLOR", val);
      }
    },
    lightOption: {
      get() {
        return this.ui.lightOption;
      },
      set(val) {
        this.$vuetify.dark = val === "dark";
        this.$store.dispatch("SET_LIGHT_OPTION", val);
      }
    }
  }
};
</script>

<style scoped>
.appDrawer {
  overflow: hidden;
}
.drawer-menu--scroll {
  overflow: auto;
  height: calc(100vh);
}
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
.color-option--label {
  position: relative;
  display: block;
  cursor: pointer;
}
.color-option--label input[type="radio"] {
  display: none;
}
.color-option--label input[type="radio"] + span {
  position: relative;
}
.color-option--label input[type="radio"] + span > .overlay {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.color-option--label input[type="radio"]:checked + span > .overlay {
  display: block;
}
.color-option--label .bg {
  background-color: #f1f1f1;
}
.color-option--item {
  overflow: hidden;
  display: block;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}
.color-option--item--header {
  height: 10px;
}
.color-option--item > span {
  display: block;
  float: left;
  width: 50%;
  height: 20px;
}
</style>
